<template>
  <div>
    <Nav></Nav>
    <mdb-container class="my-4 mt-5">
      <mdb-row class="mb-4">
        <mdb-col class="text-left">
          <h1 class="h1">{{headertitle}}</h1>
          <mdb-badge pill color="black">{{headercategory}}</mdb-badge>
          <!--<mdb-btn @click="backToList" coutline color="primary">Back to List</mdb-btn>-->
          <div @click="backToList" class="text-blue mt-3 link">Back to List</div>
        </mdb-col>
      </mdb-row>
      <mdb-row class="my-5">
        <mdb-col sm="12" md="9" class>
          <div class="post-list" v-scroll-spy="{data: 'section'}">
            <div class="post-list-item" v-for="d in detailstoloopfor" v-bind:key="d.id">
              <div class="post-list-item-author">
                <!-- <span class="avatar">{{ d.whosaidthis.substring(0,1) }}</span> -->
                <AvatarFromProfileByEmail :email="d.whosaidthis"></AvatarFromProfileByEmail>
              </div>
              <div class="post-list-item-main">
                <div class="brief">
                  <a class="name">
                    <h3>{{doSthWithWhosaidthis(d.whosaidthis)}}</h3>
                    <span class="post-list-item-date">{{doSthWithTimestamp(d.timestamp)}}</span>
                    <!-- Nov '18 -->
                    <div class="post-list-item-excerpt" v-html="d.detailtext"></div>
                  </a>
                </div>
                <!--<div class="post-list-item-reply">
                  <a href="#replybigbutton">
                    <span>Reply</span>
                  </a>
                </div>-->
              </div>
            </div>
            <!-- <div class="post-list-item">
              <div class="post-list-item-author">SK</div>
              <div class="post-list-item-main">
                <div class="brief">
                  <a class="name">
                    <h3>Simon K.</h3>
                    <span class="post-list-item-date">Nov '18</span>
                    <div class="post-list-item-excerpt">
                      We're proud to announce the release of Flarum 0.1.0-beta.8.
                      This is a huge release. It contains some massive behind-the-scenes changes which will make Flarum more reliable and streamline extension development going forward. There are also a few nifty new features, and plenty of bug fixes.
                    </div>
                  </a>
                </div>
                <div class="post-list-item-reply">
                  <a>
                    <span>Reply</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="post-list-item">
              <div>
                <div class="post-list-item-author">
                  <img
                    src="https://mdbootstrap.com/img/Photos/Avatars/img%20(17)-mini.jpg"
                    class="avatar rounded-circle"
                  >
                </div>
                <div class="post-list-item-main">
                  <div class="brief">
                    <a class="name">
                      <h3>KrzySiu</h3>
                      <span class="post-list-item-date">Nov '18</span>
                      <div
                        class="post-list-item-excerpt"
                      >Search has received a makeover. Discussion titles are now searched and results are ranked much more reliably. Search performance issues on large forums have been fixed. Search results have been redesigned making it easier to find what you're looking for.</div>
                    </a>
                  </div>
                  <div class="post-list-item-reply">
                    <a>
                      <span>Reply</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>-->
            <div class="post-write-reply">
              <div class="post-write-reply-main">
                <div class="post-write-reply-text">
                  <ckeditor :editor="editor" v-model="ckeditortext" :config="ckeditorconfig"></ckeditor>
                  <mdb-btn color="primary" class="sm mt-3" @click="saveReply">Post Reply</mdb-btn>
                </div>
              </div>
            </div>
          </div>
        </mdb-col>
        <mdb-col sm="12" md="3" class="d-none d-md-block" id="ScrollerBox">
          <div class="h-100 px-5" sticky-container>
            <div v-sticky sticky-offset="offset" sticky-side="top" id="stickyElement">
              <mdb-btn color="primary" @click="goToBottom" class="mb-4">Reply</mdb-btn>
              <div @click="goToTop" class="link">
                <mdb-icon icon="angle-double-up" />Original post
              </div>
              <div
                id="ScrollerContainer"
                class="Scroller-scrollbar"
                v-bind:style="{ height: + scrollerHeight }"
              >
                <div class="Scroller-before" style="height: 0;"></div>
                <div
                  id="Scroller"
                  class="Scroller-handle"
                  v-bind:style="{ height: + scrollerHandleHeight  }"
                >
                  <span class="Scroller-bar">
                    <!--{{windowPercent}}-->
                  </span>
                  <span class="Scroller-info">
                    <ul
                      class="menu"
                      v-scroll-spy-active="{class: 'customActive'}"
                      v-scroll-spy-link
                    >
                      <!-- <li :key="d.id" v-for="(d, index) in detailstoloopfor" class="menu-item">
                        <span>{{doSthWithWhosaidthis(index)}} of {{doSthWithWhosaidthis(detailstoloopfor.length)}}</span>
                      </li>-->
                    </ul>
                  </span>
                </div>
                <div class="Scroller-after" style="height: 100%;"></div>
              </div>
              <div @click="goToBottom" class="link">
                <mdb-icon icon="angle-double-down" />Now
              </div>

              <div class="text-white">{{this.windowPercent}}</div>
              <div class="text-white">Initial: {{initialY}}</div>

              <!--<mdb-btn coutline color="primary">Follow</mdb-btn>-->
            </div>
          </div>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <Footer></Footer>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import AvatarFromProfileByEmail from "../components/AvatarFromProfileByEmail";
import firebase from "firebase";
import moment from "moment";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Sticky from "vuejs-sticky-directive";
import { store } from "../store";

import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbIcon
} from "mdbvue";

export default {
  name: "Community",
  directives: { Sticky },
  data: function() {
    return {
      headertitle: "No discussion title",
      headercategory: "No category",
      categoriesstatic: [
        "General",
        "Tips and Tricks",
        "Why selling is important",
        "How to find clients",
        "How to sell more",
        "How to build a sales team"
      ],
      detailstoloopfor: [],

      editor: ClassicEditor,
      ckeditortext: "",
      ckeditorconfig: {
        // The configuration of the rich-text editor.
        toolbar: {
          items: [
            "bold",
            "italic",
            "link",
            "bulletedList",
            "numberedList",
            "blockQuote",
            "|",
            "undo",
            "redo"
          ]
        }
      },
      offset: {
        top: 150 // set the top breakpoint
      },
      scrolled: true,
      windowPercent: 0,
      documentHeight: 0,
      scrollPosition: 0,
      windowHeight: 0,
      scrollerHeight: 300,
      scrollerHandleHeight: 20,
      section: 0,
      currentY: 0,
      offsetY: 0,
      initialY: 0,
      scrollerOffset: 0,
      titles: [
        "Ludwig van Beethoven",
        "Biography",
        "Personal and family difficulties"
      ]
    };
  },
  methods: {
    routerize(humancat) {
      var ret = humancat.toLowerCase();
      ret = ret
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-");
      return ret;
    },
    backToList() {
      this.$router.replace(
        "/community/community-list-discussions/" +
          this.routerize(this.headercategory)
      );
    },
    saveReply() {
      //console.log("will save ckeditor");

      var discussionfirebaseid = this.$router.currentRoute.params
        .discussionfirebaseid;

      /*       console.log(
        "will save to " + discussionfirebaseid + " this " + this.ckeditortext
      ); */

      firebase
        .firestore()
        .collection("forumdiscussionsdetails")
        .add({
          detailtext: this.ckeditortext,
          discussionid: discussionfirebaseid,
          whosaidthis: store.getters.getUser
            ? store.getters.getUser.email
            : "null",
          timestamp: firebase.firestore.Timestamp.fromDate(new Date())
        });

      this.ckeditortext = "";
    },
    doSthWithTimestamp(timestamp) {
      if (timestamp) return moment(timestamp.toDate()).format("LTS");

      return "(this post has no date)";
    },
    doSthWithWhosaidthis(who) {
      if (who) return who;

      return "(anonymous)";
    },
    setMasterHeaderDiscussionNameByRouter() {
      //console.log("called setMasterHeaderDiscussionNameByRouter()");
      firebase
        .firestore()
        .collection("forumdiscussions")
        .doc(this.$router.currentRoute.params.discussionfirebaseid)
        .get()
        .then(result => {
          this.headertitle = result.data().discussionname;
        });
    },
    setMasterHeaderCategoryNameByRouter() {
      //console.log("called setMasterHeaderDiscussionNameByRouter()");
      firebase
        .firestore()
        .collection("forumdiscussions")
        .doc(this.$router.currentRoute.params.discussionfirebaseid)
        .get()
        .then(result => {
          this.headercategory = result.data().category;
        });
    },

    handleScroll() {
      this.scrolled = window.scrollY > 0;

      this.documentHeight = window.document.body.scrollHeight;
      //console.log("hadleScroll: " + window.document.body.scrollHeight);

      this.scrollPosition = window.scrollY;
      this.windowHeight = window.innerHeight;
      this.windowPercent =
        (this.scrollPosition * 100) / (this.documentHeight - this.windowHeight);

      let scrubberHeight = this.scrubberHeight;

      this.moveScrollableToY();
    },
    makeScrollable() {
      window.scrollTo({ top: 1 });
      //console.log(body.clientHeight);

      this.scrollPosition = window.scrollY;
      this.windowHeight = window.innerHeight;
      var that = this;
      //console.log("1: " + this.windowPercent);

      var dragItem = window.document.querySelector("#Scroller");
      var box = window.document.querySelector("#ScrollerBox");
      var container = window.document.querySelector("#ScrollerContainer");

      dragItem.style.height = "" + this.scrollerHandleHeight + "px";
      let containerFinalHeight =
        this.scrollerHandleHeight + this.scrollerHeight;
      container.style.height = "" + containerFinalHeight + "px";

      var percent = 0;
      //this.windowPercent = percent;

      let scrollerHeight = this.scrollerHeight;
      let scrollerHandleHeight = this.scrollerHandleHeight;

      var active = false;
      var currentX;
      var currentY;
      var initialX;
      var initialY;
      var xOffset = 0;
      var yOffset = 0;

      box.addEventListener("touchstart", dragStart.bind(container), false);
      box.addEventListener("touchend", dragEnd.bind(container), false);
      box.addEventListener("touchmove", drag.bind(container), false);

      box.addEventListener("mousedown", dragStart.bind(container), false);
      box.addEventListener("mouseup", dragEnd.bind(container), false);
      box.addEventListener("mousemove", drag.bind(container), false);

      function dragStart(e) {
        e.preventDefault();

        //console.log("Drag start =================");

        if (e.type === "touchstart") {
          //console.log("touch");
          initialX = e.touches[0].clientX - xOffset;
          initialY = e.touches[0].clientY - yOffset;
        } else {
          //console.log("drag");
          initialX = e.clientX - xOffset;
          initialY = that.currentY - yOffset;
          //initialY = that.windowPercent * that.scrollerHeight / 100;
          //console.log("DragStart: Current Y: " + currentY);
          //console.log("DragStart: Initial Y: " + initialY);

          that.initialY = initialY;
        }
        if (e.target === dragItem) {
          active = true;
        }
      }

      function dragEnd(e) {
        initialX = currentX;

        that.currentY = currentY;
        that.initialY = initialY;

        active = false;
      }

      function drag(e) {
        function offset(el) {
          var viewportOffset = el.getBoundingClientRect();
          var top = viewportOffset.top;
          return top;
        }

        var scroller = window.document.querySelector("#stickyElement");
        var divOffset = offset(scroller);
        //console.log(divOffset);
        that.scrollerOffset = divOffset;

        if (active) {
          e.preventDefault();

          if (e.type === "touchmove") {
            currentX = e.touches[0].clientX - initialX;
            currentY = e.touches[0].clientY - initialY;
          } else {
            currentX = e.clientX - initialX;
            currentY = e.clientY - initialY - that.offset.top - divOffset;
            //console.log("YY=" + e.clientY);
          }

          //console.log("Drag: Current Y: " + currentY);
          //console.log("Drag: Initial Y: " + initialY);

          xOffset = currentX;
          yOffset = currentY;

          that.initialY = initialY;
          that.currentY = currentY;

          if (currentY >= 0 && currentY <= scrollerHeight) {
            //console.log("Current: " + currentY)
            that.setTranslate(0, currentY, dragItem);
            //console.log(currentY);
          }
        }
      }
    },
    setTranslate(xPos, yPos, el) {
      let percent = (yPos * 100) / this.scrollerHeight;

      //console.log(percent);

      //console.log(percent);

      //console.log(that.window);
      //console.log("SetTranslate currentY: " + currentY);
      //console.log("SetTranslate percent: " + percent);
      this.windowPercent = percent;

      //console.log("per:" + this.percent);
      this.scrollToY();

      el.style.top = "" + yPos + "px";
    },
    scrollToY() {
      let point =
        (this.windowPercent * (this.documentHeight - this.windowHeight)) / 100;

      let point2 = (this.windowPercent * this.scrollerHeight) / 100;

      /*       console.log(
        "WindowPercent: " +
          this.windowPercent +
          ", doc height:" +
          this.documentHeight +
          ", window height: " +
          this.windowHeight +
          ", point: ",
        point
      ); */

      //if(point > 1) {  window.scrollTo(0, point) } else {window.scrollTo({ top: 0, behavior: 'smooth' }) } ;
      if (point > 70) {
        window.scrollTo({ top: point });
      }
      if (point <= 70) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }

      //window.scrollTo(0, point);
      //this.windowPercent =
      // (point * 100) / (this.documentHeight - this.windowHeight);
    },
    moveScrollableToY() {
      let point = (this.windowPercent * this.scrollerHeight) / 100;
      var dragItem = window.document.querySelector("#Scroller");
      dragItem.style.top = "" + point + "px";

      this.windowPercent = (point * 100) / this.scrollerHeight;
      //console.log("od scrollbara: " + this.windowPercent);
    },
    goToBottom() {
      window.scrollTo({ top: this.documentHeight, behavior: "smooth" });
    },
    goToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
  mounted() {
    this.makeScrollable();
    window.scrollTo(0, 0.1);
    this.documentHeight = window.document.body.scrollHeight;
    //console.log("Mounted: " + this.documentHeight);
  },
  created: function() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("onmousemove", this.handleScroll);

    this.setMasterHeaderDiscussionNameByRouter();
    this.setMasterHeaderCategoryNameByRouter();

    var refdetails = firebase
      .firestore()
      .collection("forumdiscussionsdetails")
      .where(
        "discussionid",
        "==",
        this.$router.currentRoute.params.discussionfirebaseid
      )
      .orderBy("timestamp");

    refdetails.onSnapshot(querySnapshot => {
      //console.log("onSnapshot() fired");
      this.detailstoloopfor = [];
      querySnapshot.forEach(doc => {
        // console.log(
        //   "created pushing " +
        //     doc.id +
        //     " name " +
        //     doc.data().name +
        //     " subcat " +
        //     doc.data().subcategory
        //   // + doc.collection('subcategories').forEach(function(){console.log('sth');})
        // );
        this.detailstoloopfor.push({
          id: doc.id,
          detailtext: doc.data().detailtext,
          whosaidthis: doc.data().whosaidthis,
          timestamp: doc.data().timestamp,
          detailtext: doc.data().detailtext
        });
      });
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    getUser: function() {
      return store.getters.getUser ? store.getters.getUser.email : "null";
    }
  },
  components: {
    Nav,
    Footer,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    mdbIcon,
    AvatarFromProfileByEmail
  }
};
</script>

<style>
@import url("https://use.typekit.net/lel8wuy.css");
</style>

